import { Input as DefaultInput, InputProps } from '../BGH/input';
import styles from './input.scss';

const classNames = {
  inputField: styles.inputField
};
export const Input = (props: Omit<InputProps, 'classNames'>) => (
  <DefaultInput {...props} classNames={classNames} />
);
